<script>
  import TableAreaHeaderFilterButton from "./TableAreaHeaderFilterButton.svelte";
  import { 
    resFilterInput,
    procFilterInput,
    shiftFilterInput, 
    Filters,
  } from "./loadGraphStore.js";
  export let header;
  export let rowHeight;
  export let visibleRows;

  export let handleScrollRowNum;
  export let index;
  export let startDrag;
  export let option_resourceCodes;
  export let option_processes;
  export let option_shifts;

  export let rowWidth;

  /* let minWidth = {
    '資源コード': '125px',
    '工程': '50px',
    '勤務シフト': '125px'
  } */

  const applyPreloadedSettings = (options, preload) => {
    if (!preload || preload.length === 0) return options;

    return options.map((obj) => {
      if (preload.includes(obj.text)) {
        return { ...obj, excluded: true };
      }
      return obj;
    });
  };

  if ($resFilterInput) {
    option_resourceCodes = applyPreloadedSettings(option_resourceCodes, $resFilterInput);
    Filters.update(filters => {
      filters["ResCodeFilter"].items = option_resourceCodes;
      return filters;
    });
  }

  if ($procFilterInput) {
    option_processes = applyPreloadedSettings(option_processes, $procFilterInput);
    Filters.update(filters => {
      filters["ProcessFilter"].items = option_processes;
      return filters;
    });
  }

  if ($shiftFilterInput) {
    option_shifts = applyPreloadedSettings(option_shifts, $shiftFilterInput);
    Filters.update(filters => {
      filters["ShiftFilter"].items = option_shifts;
      return filters;
    });
  }

  $: {
    resFilterInput.set(option_resourceCodes.filter((item) => item.excluded).map((item) => item.text));
    procFilterInput.set(option_processes.filter((item) => item.excluded).map((item) => item.text));
    shiftFilterInput.set(option_shifts.filter((item) => item.excluded).map((item) => item.text));
  }
</script>

<table on:wheel={handleScrollRowNum}>
  <thead>
    <tr>
      <th id="th_{index}">
        <div class="res-cell" style="width: {rowWidth}px;">
          <div class="header-text">{header}</div>
          <div class="button">
            <TableAreaHeaderFilterButton
              filterName={
                header === '資源コード' ? "ResCodeFilter" : 
                header === '工程' ? "ProcessFilter" : 
                header === '勤務シフト' ? "ShiftFilter" : ''}
              filterableItems={
                header === '資源コード' ? option_resourceCodes : 
                header === '工程' ? option_processes : 
                header === '勤務シフト' ? option_shifts : ''
              }
            />
          </div>
          <div class="empty"></div>
          <div id="resizer_{index}" class="resizer" on:mousedown={startDrag}></div>
        </div>
      </th>    
    </tr>
  </thead>
  <tbody>
    {#each visibleRows as row}
      <tr>
        <!--  on:wheel={handleScrollRowNum} -->
        <td style="position: relative;">
          <div class="normal-data" style="height: {rowHeight}px; max-height: {rowHeight}px; width: {rowWidth}px;">
            <div class="scrollable-content">
              <p class="data-text">
                {header === '資源コード' ? row.resourceCode : 
                header === '工程' ? row.process : 
                header === '勤務シフト' ? row.shift : ''}
              </p>
            </div>
            
          </div>
          <div id="resizer_{index}" class="resizer" on:mousedown={startDrag}></div>
        </td>
      </tr>
    {/each}
  </tbody>
</table>
  
<style>

  table {
    height: 100%;
    border-collapse: collapse;
    table-layout: fixed;

  }

  th,td {
    padding: 0 !important;
    border-bottom: 2px solid #888888;
    border-top: 2px solid #888888;
    border-left: 2px solid #888888;
  }

  th {
    height: 80px;
    background-color: white;
    
  }

  div.button {
    align-self: start;
    position: absolute;
    top: 2px;
    right: 2px;
  }


  td {
    background-color: #ffffff;
  }

  .res-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%; 
    box-sizing: border-box;
    position: relative;
  }

  .header-text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    height: 100%;
  }

  .empty {
    width: 100%;
    height: 26px;
    flex-shrink: 0;
  }

  .normal-data {
    background-color: #e9e9ef;
    font-size: 16px;
    font-weight: 500;
    /* overflow-y: auto; */
    overflow-y: hidden;
    overflow-x: hidden;
    text-align: center;
    box-sizing: border-box;
    position: relative;
}

  .data-text {
    margin: 0;
    display: inline-block;
  }

  .scrollable-content {
    display: flex;
    flex-direction: column;
    justify-content: center;  /* Vertically center the content */
    min-height: 100%;         /* Ensure the content stretches vertically to enable centering */
  }
  .resizer {
    position: absolute;
    top: 0;
    right: -4px;
    width: 6px;
    height: 100%;
    cursor: ew-resize;
    background-color: transparent;
    z-index: 10;
  }
</style>